import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FileItemT } from "shared/types/media";

type PayloadFile = {
  identity: string;
  file: FileItemT;
};

type FilesState = {
  items: Record<string, { files: FileItemT[] }>;
};

const initialState: FilesState = {
  items: {},
};

const chatFilesSlice = createSlice({
  name: "chat/files",
  initialState,
  reducers: {
    addItem: (state, { payload }: PayloadAction<PayloadFile>) => {
      if (!state.items[payload.identity]) {
        state.items[payload.identity] = {
          files: [],
        };
      }

      let alreadyExist = false;
      let iteration = 0;

      for (const file of state.items[payload.identity].files) {
        if (file.uid === payload.file.uid) {
          state.items[payload.identity].files[iteration] = payload.file;
          alreadyExist = true;
          break;
        }

        iteration++;
      }

      if (!alreadyExist) {
        state.items[payload.identity].files.push(payload.file);
      }
    },
    deleteItem: (state, { payload }: PayloadAction<PayloadFile>) => {
      if (state.items[payload.identity]?.files) {
        let iteration = 0;
        for (const file of state.items[payload.identity].files) {
          if (file.uid === payload.file.uid) {
            state.items[payload.identity].files.splice(iteration, 1);
            break;
          }

          iteration++;
        }
      }
    },
    deleteChannelItems: (
      state,
      { payload }: PayloadAction<Pick<PayloadFile, "identity">>
    ) => {
      if (state.items[payload.identity]?.files) {
        state.items[payload.identity].files = [];
      }
    },
  },
});

export const { addItem, deleteItem, deleteChannelItems } =
  chatFilesSlice.actions;

export default chatFilesSlice.reducer;
